import $ from 'jquery';
	window.jQuery = $;
	window.$ = $;
	
import { TweenMax, CSSPlugin } from "gsap/TweenMax";

import Main from './Main';

import videojs from 'video.js';
	window.videojs = videojs;

import {Howl, Howler} from 'howler';

(function (w) {

    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
            }
        };
    }

})(window)

import Mediator from './Mediator';
global.MEDIATOR = new Mediator();
MEDIATOR.init();

$(document).ready(() => {
	const main = new Main();
	main.init();
});